import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from "recompose";
import config from 'config';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import Grid from '@material-ui/core/Grid';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Avatar from '@material-ui/core/Avatar';

import FolderIcon from '@material-ui/icons/Folder';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import CertFormComponent from '../Profile/CertFormComponent';

import IntegrationReactSelect from '../Common/IntegrationReactSelect';
import CardAvatar from "../../modules/Card/CardAvatar.jsx";
import owl from "../../images/owl-2.png";
import TagsComponent from '../Common/TagsComponent';
import { userActions } from '../../_actions';
import { checkValue } from '../../_helpers';
import Progress from '../Common/Progress';

const styles = theme => ({
    button: {
        margin: theme.spacing.unit,
    },
    paper: {
        position: 'absolute',
        width: '90%',
        height: '90%',
        overflow: 'auto',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit * 4,
    },
    textField: {
        width: '90%',
        margin: theme.spacing.unit,
    },
    margin: {
        margin: theme.spacing.unit,
    },
    formControl: {
        margin: theme.spacing.unit * 3,
    },
});

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

class UserFormComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mode: 'ADD',
            modalTitle: 'Add User',
            openProgress: false,
            openCertForm: false,

            CertificationsData: [],

            UserIdValid: true,
            UserNameValid: true,
            FirstNameValid: true,
            LastNameValid: true,
            DepartmentIdValid: true,
        };

        this.handleCertEditClick = this.handleCertEditClick.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.userData && nextProps.userData !== this.props.userData && nextProps.userData !== undefined) {
            const usersData = nextProps.userData;

            this.setState({
                UserId: usersData.UserId,
                UserAd: usersData.UserAd,
                UserName: usersData.UserName,
                Email: usersData.Email,
                DepartmentId: usersData.DepartmentId,
                JobTitle: usersData.JobTitle ? usersData.JobTitle : '',
                FirstName: usersData.FirstName,
                LastName: usersData.LastName,
                F: usersData.Certifications === null ? false : usersData.Certifications.F,
                AA: usersData.Certifications === null ? false : usersData.Certifications.AA,
                SEA: usersData.Certifications === null ? false : usersData.Certifications.SEA,
                SAE: usersData.Certifications === null ? false : usersData.Certifications.SAE,
                AIA: usersData.Certifications === null ? false : usersData.Certifications.AIA,
                DEA: usersData.Certifications === null ? false : usersData.Certifications.DEA,
                DSA: usersData.Certifications === null ? false : usersData.Certifications.DSA,
                DA: usersData.Certifications === null ? false : usersData.Certifications.DA,
                DEE: usersData.Certifications === null ? false : usersData.Certifications.DEE,
                AboutMe: usersData.AboutMe !== null ? usersData.AboutMe : '',
                ImagePreviewUrl:
                    checkValue(usersData.AvatarUrl)
                        ? `${config.ApplicationS3BucketEndpoint}/` + usersData.AvatarUrl + '.png'
                        : null,
                AvatarUrl: usersData.AvatarUrl,
                Password: usersData.Password,
                Tag: usersData.Tag,
                Certifications: usersData.Certifications,
                CertificationsData: usersData.CertificationsData,
                IsAdmin: usersData.IsAdmin,
                IsSales: usersData.IsSales,

                mode: 'EDIT',
                modalTitle: 'Edit User',
            });
        }
        else {
            this.cleanData();
        }
    }

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };

    handleCheckedChange = name => event => {
        this.setState({ [name]: event.target.checked });
    };

    handleSave = () => {
        let TextFieldVaild = true;
        if (this.state.UserId === '') {
            this.setState({
                UserIdValid: false
            })
            TextFieldVaild = false;
        }

        if (this.state.UserAd === '') {
            this.setState({
                UserAdValid: false
            })
            TextFieldVaild = false;
        }

        if (this.state.UserName === '') {
            this.setState({
                UserNameValid: false
            })
            TextFieldVaild = false;
        }

        if (this.state.FirstName === '') {
            this.setState({
                FirstNameValid: false
            })
            TextFieldVaild = false;
        }

        if (this.state.LastName === '') {
            this.setState({
                LastNameValid: false
            })
            TextFieldVaild = false;
        }

        if (this.state.DepartmentId === '') {
            this.setState({
                DepartmentIdValid: false
            })
            TextFieldVaild = false;
        }

        const DataProcessing = async () => {
            try {
                await this.setState({
                    openProgress: true,
                })

                const certifications = {
                    'F': this.state.F,
                    'AA': this.state.AA,
                    'SEA': this.state.SEA,
                    'SAE': this.state.SAE,
                    'AIA': this.state.AIA,
                    'DEA': this.state.DEA,
                    'DSA': this.state.DSA,
                    'DA': this.state.DA,
                    'DEE': this.state.DEE
                };

                const inputData = {
                    'UserId': this.state.UserId,
                    'UserAd': this.state.UserAd,
                    'UserName': this.state.UserName,
                    'Email': this.state.Email,
                    'DepartmentId': this.state.DepartmentId,
                    'JobTitle': this.state.JobTitle,
                    'FirstName': this.state.FirstName,
                    'LastName': this.state.LastName,
                    'Certifications': JSON.parse(JSON.stringify(certifications)),
                    'CertificationsData': this.state.CertificationsData ? JSON.parse(JSON.stringify(this.state.CertificationsData)) : '',
                    'AboutMe': this.state.AboutMe,
                    'IsSales': this.state.IsSales ? this.state.IsSales : false,
                    'IsAdmin': this.state.IsAdmin ? this.state.IsAdmin : false,
                    'AvatarUrl': this.state.AvatarUrl ? this.state.AvatarUrl : '',
                    'Tag': JSON.stringify(this.state.Tag),
                    'Password': this.state.Password,
                    'CreatedUserId': this.props.user.id,
                    'UpdatedUserId': this.props.user.id
                };

                if (this.state.mode === 'ADD') {
                    await this.props.dispatch(userActions.insert({ data: inputData }));
                }
                else if (this.state.mode === 'EDIT') {
                    await this.props.dispatch(userActions.update({ data: inputData }));
                }

                await this.props.dispatch(userActions.getAll());
                await this.handleClose();

            } catch (e) {
                console.error("Problem", e)
            }
        }

        if (TextFieldVaild) {
            DataProcessing();
        }
        else {
            alert('Warning!')
        }
    }

    handleClose = () => {
        this.cleanData();
        this.props.close();
    }

    handleSelectData = (data) => {
        if (data.type === 'DepartmentId') {
            this.setState({
                DepartmentId: data.id
            })
        }
    }

    cleanData() {
        this.setState({
            UserId: '',
            UserAd: '',
            UserName: '',
            Email: '',
            DepartmentId: '',
            JobTitle: '',
            FirstName: '',
            LastName: '',
            F: false,
            AA: false,
            SEA: false,
            SAE: false,
            AIA: false,
            DEA: false,
            DSA: false,
            DA: false,
            DEE: false,
            AboutMe: '',
            ImagePreviewUrl: null,
            Tag: [],
            IsAdmin: false,
            IsSales: false,

            UserIdValid: true,
            UserAdValid: true,
            UserNameValid: true,
            FirstNameValid: true,
            LastNameValid: true,
            DepartmentIdValid: true,

            mode: 'ADD',
            modalTitle: 'Add User',
            openProgress: false,
        });
    }

    handleMultiTag = (TagData) => {
        this.setState({
            Tag: TagData
        })
    }

    handleAddCertClick = () => {
        this.setState({
            openCertForm: true,
            CertId: -1
        })
    }

    handleAddCertClose = () => {
        this.setState({
            openCertForm: false,
        })
    }

    handleCertData = (data) => {
        this.setState({
            CertificationsData: data,
            CertId: -1
        })
    }

    handleCertEditClick = (id) => {
        this.setState({
            openCertForm: true,
            CertId: id
        })
    }

    render() {
        const { classes, departments } = this.props;
        const { F, AA, SEA, SAE, AIA, DEA, DSA, DA, DEE } = this.state;

        return (
            <div>
                <Progress openProgress={this.state.openProgress} />
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.props.open}
                    onClose={this.handleClose}
                >
                    <div style={getModalStyle()} className={classes.paper}>
                        <CardAvatar profile style={{ marginTop: '0px' }}>
                            <Avatar style={{ height: '130px', width: '130px' }}
                                alt={this.state.UserName}
                                src={this.state.ImagePreviewUrl !== null ? this.state.ImagePreviewUrl : owl}
                                imgProps={{ onError: (e) => { e.target.src = owl; } }}
                            />
                        </CardAvatar>

                        <Typography id="modal-title" style={{ fontSize: 40 }}>
                            {this.state.modalTitle}
                        </Typography>

                        <Grid container>
                            <Grid item xs={6} sm={6} md={4}>
                                <TextField
                                    error={!this.state.UserIdValid}
                                    label="*User ID"
                                    id="userid"
                                    fullWidth
                                    value={this.state.UserId}
                                    className={classes.textField}
                                    onChange={this.handleChange('UserId')}
                                />
                                <TextField
                                    error={!this.state.UserNameValid}
                                    label="*User Name"
                                    id="username"
                                    fullWidth
                                    value={this.state.UserName}
                                    className={classes.textField}
                                    onChange={this.handleChange('UserName')}
                                />
                                <TextField
                                    error={!this.state.FirstNameValid}
                                    label="*First Name"
                                    id="first-name"
                                    fullWidth
                                    value={this.state.FirstName}
                                    className={classes.textField}
                                    onChange={this.handleChange('FirstName')}
                                />
                                <TextField
                                    error={!this.state.LastNameValid}
                                    label="*Last Name"
                                    id="last-name"
                                    fullWidth
                                    value={this.state.LastName}
                                    className={classes.textField}
                                    onChange={this.handleChange('LastName')}
                                />
                            </Grid>
                            <Grid item xs={6} sm={6} md={4}>
                                <IntegrationReactSelect
                                    disabledDefaultOptions={true}
                                    handleSelectData={this.handleSelectData}
                                    options={convertDepartmentOptions(departments.items)}
                                    valid={this.state.DepartmentIdValid}
                                    value={this.state.DepartmentId}
                                    placeholder='*Project Team'
                                />
                                <TextField
                                    label="Job Title"
                                    id="job-title"
                                    fullWidth
                                    value={this.state.JobTitle}
                                    className={classes.textField}
                                    onChange={this.handleChange('JobTitle')}
                                />
                                <TextField
                                    id="outlined-multiline-static"
                                    label="About Me"
                                    multiline
                                    rows="4"
                                    value={this.state.AboutMe}
                                    onChange={this.handleChange('AboutMe')}
                                    className={classes.textField}
                                    margin="normal"
                                    variant="outlined"
                                />
                            </Grid>
                            <Grid item xs={6} sm={6} md={4}>
                                <TextField
                                    label="Email address"
                                    id="email-address"
                                    fullWidth
                                    value={this.state.Email}
                                    className={classes.textField}
                                    onChange={this.handleChange('Email')}
                                />
                                <TextField
                                    error={!this.state.UserAdValid}
                                    label="*User AD"
                                    id="UserAd"
                                    fullWidth
                                    value={this.state.UserAd}
                                    className={classes.textField}
                                    onChange={this.handleChange('UserAd')}
                                />
                                <div style={{ marginLeft: '20px', marginTop: '30px' }}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={this.state.IsSales}
                                                onChange={this.handleCheckedChange('IsSales')}
                                                value="IsSales"
                                            />
                                        }
                                        label="IsSales"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={this.state.IsAdmin}
                                                onChange={this.handleCheckedChange('IsAdmin')}
                                                value="IsAdmin"
                                            />
                                        }
                                        label="IsAdmin"
                                    />
                                </div>
                            </Grid>
                        </Grid>
                        <FormControl component="fieldset" className={classes.formControl}>
                            <FormLabel component="legend">Certified</FormLabel>
                            <FormGroup row>
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={F} onChange={this.handleCheckedChange('F')} value="Fundamentals" />
                                    }
                                    label="Azure Fundamentals"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={AA} onChange={this.handleCheckedChange('AA')} value="Administrator Associate" />
                                    }
                                    label="Azure Administrator Associate"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={SEA} onChange={this.handleCheckedChange('SEA')} value="Security Engineer Associate" />
                                    }
                                    label="Azure Security Engineer Associate"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={SAE} onChange={this.handleCheckedChange('SAE')} value="Solutions Architect Expert" />
                                    }
                                    label="Azure Solutions Architect Expert"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={AIA} onChange={this.handleCheckedChange('AIA')} value="AI Engineer Associate" />
                                    }
                                    label="Azure AI Engineer Associate"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={DEA} onChange={this.handleCheckedChange('DEA')} value="Data Engineer Associate" />
                                    }
                                    label="Azure Data Engineer Associate"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={DSA} onChange={this.handleCheckedChange('DSA')} value="Data Scientist Associate" />
                                    }
                                    label="Azure Data Scientist Associate"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={DA} onChange={this.handleCheckedChange('DA')} value="Developer Associate" />
                                    }
                                    label="Azure Developer Associate"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={DEE} onChange={this.handleCheckedChange('DEE')} value="DevOps Engineer Expert" />
                                    }
                                    label="Azure DevOps Engineer Expert"
                                />
                            </FormGroup>
                        </FormControl>

                        <FormLabel component="legend">
                            Licenses & Certifications
                            <Tooltip title="Add" placement="bottom">
                                <IconButton onClick={(e) => this.handleAddCertClick(e)} color="inherit" >
                                    <AddIcon />
                                </IconButton>
                            </Tooltip>
                        </FormLabel>

                        <CertFormComponent
                            open={this.state.openCertForm}
                            close={this.handleAddCertClose}
                            handleCertData={this.handleCertData}
                            CertId={this.state.CertId}
                            CertificationsData={this.state.CertificationsData} />
                        <List dense={false}>
                            {
                                this.state.CertificationsData && this.state.CertificationsData.map((item, index) => {
                                    return (
                                        <ListItem key={index}>
                                            <ListItemAvatar>
                                                <Avatar>
                                                    <FolderIcon />
                                                </Avatar>
                                            </ListItemAvatar>
                                            <ListItemText
                                                style={{ width: '10vh' }}
                                                primary={item.CertificationName}
                                                secondary={item.IssuingOrganization}
                                            />
                                            {
                                                item.CredentialUrl &&
                                                <ListItemText
                                                    style={{ width: '10vh' }}
                                                    primary={item.CredentialId}
                                                    secondary={<a href={item.CredentialUrl} target="_blank">See Credential</a>}
                                                />
                                            }

                                            {
                                                !this.state.disabledForMore
                                                    ?
                                                    <ListItemSecondaryAction>
                                                        <Tooltip title="Edit" placement="bottom">
                                                            <IconButton aria-label="Edit" onClick={(e) => this.handleCertEditClick(index)}>
                                                                <EditIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </ListItemSecondaryAction>
                                                    : null
                                            }
                                        </ListItem>
                                    )
                                })
                            }
                        </List>

                        <div style={{ marginTop: '40px' }} />
                        <TagsComponent handleMultiTag={this.handleMultiTag} tags={this.state.Tag} />

                        <div style={{ marginTop: '20px' }} />
                        <Button color="secondary" variant="outlined" className={classes.button} onClick={this.handleSave}>
                            Save
                        </Button>
                        <Button variant="outlined" className={classes.button} onClick={this.handleClose}>
                            Cancel
                        </Button>
                    </div>
                </Modal>
            </div>
        );
    }
}

function convertDepartmentOptions(DepartmentsData) {
    const suggestions = DepartmentsData ? DepartmentsData.filter(function (item) {
        return item.DepartmentStatus === 'A'
    }).map(suggestion => ({
        type: 'DepartmentId',
        label: suggestion.DepartmentId + ' - ' + suggestion.DepartmentName,
        id: suggestion.DepartmentId,
    })) : null;

    return suggestions
}

function mapStateToProps(state) {
    const { user } = state.authentication;
    const { users, departments } = state;

    return {
        user,
        users,
        departments
    };
}

UserFormComponent.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default compose(connect(mapStateToProps), withStyles(styles))(UserFormComponent);


// WEBPACK FOOTER //
// ./src/components/Admin/UserFormComponent.js